<script lang="ts">
    import {Button, Modal, Spinner} from "flowbite-svelte";
    import {onMount} from "svelte";
    import {get} from "$lib/api";
    import dayjs from "dayjs";
    import {mailStatus} from "$lib/stores/mailStatus";

    let loading = true;
    let modalOpen = false;
    let modalContentKey = 'bounces';
    let statusData = $mailStatus;

    const openModal = (which: string) => {
        modalContentKey = which;
        modalOpen = true;
    }



    const states = [
        'unspecified error', 'user unknown (recipient)', 'mailbox inactive (recipient)', 'quota exceeded (recipient)', 'invalid domain (domain)', 'no mail host (domain)',
        'relay/access denied (domain)', 'sender blocked (spam)', 'content blocked (spam)', 'policy issue (spam)', 'system issue (system)', 'protocol issue (system)',
        'connection issue (system)', 'greylisted (domain)', 'preblocked (Mailjet)', 'duplicate in campaign (Mailjet)', 'spam preblocked (Mailjet)', 'bad or empty template (content)',
        'error in template language (content)', 'typofix (domain)', 'blacklisted (recipient)', 'spam reporter (recipient)'
    ];

    onMount(() => {
        const now = (new Date()).getTime();
        if(now - $mailStatus.age > 1000 * 60 * 15) {
            get('/mail-statistics').then(res => {
                $mailStatus.age = now;
                $mailStatus.results = res;
                $mailStatus.bounces = res.reduce((accumulator:number, current:any) => accumulator + current['MessageHardBouncedCount'], 0);
                $mailStatus.clicks = res.reduce((accumulator:number, current:any) => accumulator + current['MessageClickedCount'], 0);
                $mailStatus.opened = res.reduce((accumulator:number, current:any) => accumulator + current['MessageOpenedCount'], 0);
                loading = false;
            });
        } else {
            loading = false;
        }


    })
</script>
{#if loading}
    <div class="grid place-items-center">
        <Spinner size="12"/>
    </div>
{:else }
    <div class="grid grid-cols-3 gap-1">
        <Button on:click={() => openModal('opened')}> {statusData.opened} Opened</Button>
        <Button on:click={() => openModal('clicks')} color="green"> {statusData.clicks} Clicked</Button>
        <Button on:click={() => openModal('bounces')} color="red"> {statusData.bounces} Bounced</Button>
    </div>
{/if}
<Modal bind:open={modalOpen}>
    <h3>Stats</h3>
    {#if statusData}
        {#each statusData.results || [] as item}
            <div class="flex gap-3 justify-between">
                <span>{dayjs(item['Timeslice'].split('T')[0]).format('DD.MM.YYYY')} <br>Emails: {item['Total']}</span>
                <div>Opened: {item['MessageOpenedCount']} <br>Clicked: {item['MessageClickedCount']}</div>
                <div>Blocked: {item['MessageBlockedCount']} <br>Bounced: {item['MessageHardBouncedCount']} <br>Spam: {item['MessageSpamCount']}</div>
            </div>
        {/each}
    {/if}
</Modal>